import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Search, Globe, Clock, BarChart, Layers, Rocket, Link2, FileSearch, Settings, Share2 } from 'lucide-react';

export const SEOGuide = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      icon: <Search className="w-8 h-8 text-blue-300" />,
      title: t('seoGuide.sections.whatIsSeo.title'),
      content: t('seoGuide.sections.whatIsSeo.content')
    },
    {
      icon: <Globe className="w-8 h-8 text-purple-300" />,
      title: t('seoGuide.sections.whyImportant.title'),
      content: t('seoGuide.sections.whyImportant.content')
    },
    {
      icon: <Layers className="w-8 h-8 text-blue-300" />,
      title: t('seoGuide.sections.basicElements.title'),
      content: t('seoGuide.sections.basicElements.content')
    },
    {
      icon: <FileSearch className="w-8 h-8 text-purple-300" />,
      title: t('seoGuide.sections.keywords.title'),
      content: t('seoGuide.sections.keywords.content')
    },
    {
      icon: <Settings className="w-8 h-8 text-blue-300" />,
      title: t('seoGuide.sections.technical.title'),
      content: t('seoGuide.sections.technical.content')
    },
    {
      icon: <Link2 className="w-8 h-8 text-purple-300" />,
      title: t('seoGuide.sections.linking.title'),
      content: t('seoGuide.sections.linking.content')
    },
    {
      icon: <BarChart className="w-8 h-8 text-blue-300" />,
      title: t('seoGuide.sections.monitoring.title'),
      content: t('seoGuide.sections.monitoring.content')
    },
    {
      icon: <Clock className="w-8 h-8 text-purple-300" />,
      title: t('seoGuide.sections.timeline.title'),
      content: t('seoGuide.sections.timeline.content')
    },
    {
      icon: <Share2 className="w-8 h-8 text-blue-300" />,
      title: t('seoGuide.sections.social.title'),
      content: t('seoGuide.sections.social.content')
    },
    {
      icon: <Rocket className="w-8 h-8 text-purple-300" />,
      title: t('seoGuide.sections.bestPractices.title'),
      content: t('seoGuide.sections.bestPractices.content')
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950 pt-24 pb-20">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 text-gradient text-glow leading-tight">
          {t('seoGuide.title')}
        </h1>
        <p className="text-blue-200/80 text-center mb-12 max-w-3xl mx-auto text-lg">
          {t('seoGuide.subtitle')}
        </p>

        <div className="grid gap-8 max-w-4xl mx-auto">
          {sections.map((section, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-xl p-8 border border-white/10 transition-all duration-300 hover:bg-white/10"
            >
              <div className="flex items-center mb-4">
                {section.icon}
                <h2 className="text-2xl font-bold ml-4 text-white leading-tight">{section.title}</h2>
              </div>
              <div className="text-blue-200/80 whitespace-pre-line leading-relaxed">
                {section.content}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-blue-200/80 mb-8">
            {t('seoGuide.cta')}
          </p>
          <div className="relative group inline-block">
            <div className="absolute -inset-[1px] rounded-lg bg-gradient-to-r from-blue-500/50 via-purple-500/50 to-blue-500/50 blur-sm animate-border-flow"></div>
            <div className="absolute -inset-[1px] rounded-lg bg-gradient-to-r from-blue-500 via-purple-500 to-blue-500 animate-border-flow"></div>
            <a
              href="#contact"
              className="relative block bg-slate-950 px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 text-white font-semibold"
            >
              {t('seoGuide.contact')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};